import { gql } from '@apollo/client';

export default gql`
  query GetPersonCollections(
    $tags: [String]
    $userId: Int
    $orderBy: CollectionsSortOrder
    $orderByDirection: SortOrderDirection
    $limit: Int
    $offset: Int
  ) {
    Collections(
      tags: $tags
      userId: $userId
      orderBy: $orderBy
      orderByDirection: $orderByDirection
      limit: $limit
      offset: $offset
    ) {
      id
      name
      plain_description
      cover_image {
        id
        book {
          isbn
          image_name
          image_permission
        }
        primary_image {
          credit
          crops {
            sizes {
              src
              w
              h
            }
            type
          }
          graphictype
          height
          id
          src
          type
          width
        }
        graphics {
          src
          type
          graphictype
          height
          width
          credit
        }
        instagram_url
      }
      custom_cover_image
      display_name
      visibility
      items_count {
        total
      }
    }
  }
`;
